import { render } from "./follow_request_card.vue?vue&type=template&id=3bb26ea8"
import script from "./follow_request_card.js?vue&type=script&lang=js"
export * from "./follow_request_card.js?vue&type=script&lang=js"

import "./follow_request_card.vue?vue&type=style&index=0&id=3bb26ea8&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__